import { FC, useEffect, useState, useCallback, useRef } from "react";
import ScreenWrapper from "shared/ui/screen-wrapper";
import { useSelector } from "store/helpers";
import { PageLoadingStatus } from "enums/page-loading-status";
import LoadingScreen from "shared/ui/loading-screen";
import { AssignmentRelationType } from "@kolibrisoftware/customerportal-api";
import { usePersistentIframe } from "providers/iframe/hooks";

const EerlijkBiedenScreen: FC = () => {
  const loadingStatus = useSelector(state => state.dossier.loadingStatus);
  const iframeSrc = useSelector(
    state => state.dossier.assignmentDetails.safeBiddingPlatformUrl
  );
  const { setSrc, setVisible, setStyle } = usePersistentIframe();
  const { userLinkType } = useSelector(state => state.dossier);
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 800);
  const lastIsMobileRef = useRef(isMobile);

  const updateStyling = useCallback(
    (mobile: boolean) => {
      setStyle({
        height: `calc(100% - ${isMobile ? "141px" : "114px"}`,
        minWidth: "100%",
        left: "0",
        position: "relative",
        right: "0",
        top: isMobile ? "61px" : "114px",
      });
    },
    [isMobile, setStyle]
  );

  useEffect(() => {
    const handleResize = () => {
      const isNowMobile = window.innerWidth <= 800;
      if (isNowMobile !== lastIsMobileRef.current) {
        lastIsMobileRef.current = isNowMobile;
        setIsMobile(isNowMobile);
        updateStyling(isNowMobile);
      }
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, [updateStyling]);

  useEffect(() => {
    updateStyling(isMobile);
  }, [isMobile, updateStyling]);

  useEffect(() => {
    if (userLinkType === AssignmentRelationType.Potential) {
      setVisible(true);
    }

    return () => {
      setVisible(false);
    };
  }, [userLinkType, setVisible, updateStyling]);

  useEffect(() => {
    if (iframeSrc) {
      setSrc(iframeSrc);
    }
  }, [iframeSrc, setSrc]);

  return (
    <ScreenWrapper>
      {(loadingStatus === PageLoadingStatus.Loading ||
        loadingStatus === PageLoadingStatus.Pending) && <LoadingScreen />}

      {loadingStatus === PageLoadingStatus.Success && (
        // Iframe is persistent and managed in the iframe provider.
        <></>
      )}
    </ScreenWrapper>
  );
};

export { EerlijkBiedenScreen };
